import saveEditorData from '../../Common/saveEditorData';
import destroyEditorData from '../../Common/destroyEditorData';
import router from '../../../router/routes';
import axios from 'axios';

export default {
    namespaced: true,

    state: {
        siteId: '',
        sectionId: false,
        sectionRoute: '/api/site/create',
        sectionName: '',
        sectionSubtitle: '',
        sectionCards: [],
        sectionData: [],
        stepName: '',
        permissable: true,
    },

    mutations: {
        setSectionId(state, value) {
            state.sectionId = value;
        },

        setSectionData(state, value) {
            state.sectionData = value;
        },

        setSectionName(state, value) {
            state.sectionName = value;
        },

        setSectionSubtitle(state, value) {
            state.sectionSubtitle = value;
        },

        setSectionCards(state, value) {
            state.sectionCards = value;
        },

        setStepName(state, value) {
            state.stepName = value;
        },

        setPermissable(state, value) {
            state.permissable = value;
        }
    },

    actions: {
        getSectionData({ commit, state }) {
            commit('overlay/toggle', true, { root: true });
            commit('setSectionId', router.currentRoute.params.id ? router.currentRoute.params.id : false);

            if (state.sectionId) {
                axios.get(state.sectionRoute + '/' + state.sectionId)

                    // Success
                    .then((response) => {
                        const sd = response.data.section;
                        commit('setStepName', sd.step.name);
                        commit('setSectionData', sd);
                        commit('setSectionName', sd.name);
                        commit('setSectionSubtitle', sd.subtitle);
                        commit('setSectionCards', sd.cards);
                        commit('setPermissable', true);
                        commit('overlay/toggle', false, { root: true });
                    })

                    // If there's an error here, the item doesn't exist.
                    .catch(() => {
                        // Show an error message.
                        commit('setPermissable', false);
                    });
            }
        },

        saveData({ getters, commit }) {
            saveEditorData('site', getters.route, getters.postData)
                .then((siteId) => {
                    if (router.currentRoute.name === 'StepEdit') {
                        commit('overlay/toggle', false, { root: true });
                    } else {
                        router.push('/site/edit/' + siteId);
                    }
                })
                .catch(() => {});
        },

        destroyData({ state }) {
            destroyEditorData('/api/site/delete/' + state.siteId)
                .then(() => {})
                .catch(() => {});
        },
    },
};
